import _ from 'lodash';
import React, { Component } from 'react';
import { Tabs, Tab } from 'react-toolbox/lib/tabs';
import { InspCarousel } from 'containers';
import styles from './TabbedViewAssign.css';

const debug = _debug('app:TabbedViewAssign');
export default class TabbedViewAssign extends Component {
  static propTypes = {
    clickedIndex: React.PropTypes.number,
    tabIndexLeadsCheck: React.PropTypes.number,
    closeCarousel: React.PropTypes.func,
    refreshTable: React.PropTypes.func,
    listData: React.PropTypes.shape({}),
    secondaryLeads: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    strings: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    manageCampaignData: React.PropTypes.shape([]),
    ownerId: React.PropTypes.string,
    currentLanguage: React.PropTypes.string,
  }

  constructor() {
    super();
    this.state = {
      index: 0
    };
  }

  handleFixedTabChange = (index) => {
    this.setState({
      ...this.state,
      index
    });
  }

  renderTabView = () => {
    const tabData = [this.props.listData, ..._.orderBy(this.props.secondaryLeads, ['age'], ['desc']).slice(0, 4)];
    debug('tabData', tabData);
    return tabData.map((record) => {
      const campaignDataRecordsNet = this.props.manageCampaignData.filter(recordObj =>
      record.personId && recordObj.cica_name &&
      record.personId.indexOf(recordObj.cica_name) > -1);
      return (
        <Tab
          label={record.name}
          activeClassName={record.leadType === 'Campaign' &&
          record.campaign &&
          campaignDataRecordsNet &&
          campaignDataRecordsNet.length > 0 ? styles.activeTabCampaign : styles.activeTab}
          className={record.leadType === 'Campaign' &&
          record.campaign &&
          campaignDataRecordsNet &&
          campaignDataRecordsNet.length > 0 ? styles.tabStylingCampaign : styles.tabStyling}
        >
          <InspCarousel
            closeCarousel={this.props.closeCarousel}
            clickedIndex={this.props.clickedIndex}
            listData={record}
            refreshTable={this.props.refreshTable}
            strings={this.props.strings}
            tabIndexLeadsCheck={this.props.tabIndexLeadsCheck}
            currentLanguage={this.props.currentLanguage}
            ownerId={this.props.ownerId}
          />
        </Tab>
      );
    });
  }

  render() {
    return (
      <div className={styles.tabsContainer}>
        <Tabs
          index={this.state.index}
          onChange={this.handleFixedTabChange}
          fixed
          className={styles.tabsComponent}
          theme={styles}
        >
          {this.renderTabView()}
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/TabbedViewAssign/TabbedViewAssign.js